import { useCallback } from 'react';
import { atom, useRecoilState } from 'recoil';

export interface ImageLightboxState {
  isOpen: boolean;
  images: string[];
  index: number;
}

export const imageLightboxState = atom<ImageLightboxState>({
  key: 'imageLightboxState',
  default: {
    isOpen: false,
    images: [],
    index: 0,
  },
});

export const useImageLightboxState = () => {
  const [state, setState] = useRecoilState(imageLightboxState);

  const setIndex = useCallback(
    (index: number | 'next' | 'previous') => {
      const { index: currentIndex } = state;
      const { length } = state.images;
      let updatedIndex: number = typeof index === 'number' ? index : currentIndex;
      if (index === 'next') updatedIndex = (currentIndex + 1) % length;
      else if (index === 'previous') updatedIndex = (currentIndex + length - 1) % length;
      setState({ ...state, index: updatedIndex });
    },
    [setState, state],
  );

  const open = useCallback(
    (images: ImageLightboxState['images'], index: number = state.index) => {
      setState({ ...state, isOpen: true, images, index });
    },
    [setState, state],
  );

  const close = useCallback(() => {
    setState({ ...state, isOpen: false, images: [] });
  }, [setState, state]);

  return { ...state, open, close, setIndex };
};
